<template>
  <div class="dashboard">
    <CalicoGlobalNavigation @drawer="show = !show" />
    <div class="page">
      <slot
        name="drawer"
        :show="show"
      />
      <div
        class="workspace-container"
        @click="show = false"
      >
        <div class="workspace">
          <div
            v-if="$slots.header"
            class="header"
          >
            <slot
              v-if="!loading"
              name="header"
            />
          </div>
          <div
            v-if="$slots.attributes"
            class="attributes"
          >
            <slot
              v-if="!loading"
              name="attributes"
            />
          </div>
          <div
            v-if="$slots.content"
            class="body"
            :style="{overflow: overflow ? 'auto' : 'unset'}"
          >
            <CalicoLoader v-if="loading" />
            <div
              v-else
              class="content"
              :class="{ 'content--no-padding': noContentPadding }"
            >
              <slot name="content" />
            </div>
          </div>
        </div>
        <div
          v-if="$slots.footer"
          class="footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoGlobalNavigation from "@/components/pattern/globalNavigation/index.vue";
import CalicoLoader from '@/components/calico/loader/index.vue';

export default {
  name: "CalicoDashboard",
  components: {
    CalicoGlobalNavigation,
    CalicoLoader
  },
  props: {
    noContentPadding: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard {
  @include stack-space($space-none);
  width: 100%;
  height: 100vh;
  align-items: center;
  .page {
    @include inline-space($space-none);
    position: relative;
    flex: 1;
    width: 100%;
    max-width: $large-screen-max-width;
    overflow: hidden;
    .workspace-container {
      @include stack-space($space-none);
      position: relative;
      height: 100%;
      width: 100%;
      padding: 0px $space-large;
      align-items: center;
      .workspace {
        @include stack-space($space-small);
        height: 100%;
        width: 100%;
        max-width: 740px;
        border-radius: $radius-large $radius-large $radius-none $radius-none;
        overflow: auto;
        scrollbar-width: none;
        .header {
          margin-bottom: -$radius-large;
          .calico-loader {
            padding-bottom: $radius-large;
          }
        }
        .attributes {
          background-color: $color-black;
          margin-bottom: -$radius-large;
        }
        .body {
          display: flex;
          flex: 1;
          .calico-loader {
            padding: $space-xlarge $space-medium;
          }
          border-radius: $radius-large $radius-large $radius-none $radius-none;
          background: $color-background-secondary;
          justify-content: center;
          .content {
            padding: $space-xlarge $space-medium;
            width: 100%;
            max-width: 600px;
            &.content--no-padding {
              padding: 0;
            }
          }
        }
      }
      .footer {
        background: $color-background-secondary;
        width: 100%;
        max-width: 740px;
      }
    } 
  }
}
</style>